/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_TriggerInputs */

const en_templates_trigger = /** @type {(inputs: Templates_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger`)
};

const he_templates_trigger = /** @type {(inputs: Templates_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טריגר`)
};

/**
* | output |
* | --- |
* | "Trigger" |
*
* @param {Templates_TriggerInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_trigger = /** @type {((inputs?: Templates_TriggerInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_TriggerInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_trigger(inputs)
	return he_templates_trigger(inputs)
});